import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'plugin-preview-advanced',
  templateUrl: './plugin-preview-advanced.component.html',
  styleUrls: ['./plugin-preview-advanced.component.scss'],
  standalone: false,
})
export class PluginPreviewAdvancedComponent {
  @Input() config: ShopPlugin.ProductPagePromise.Config;
  @Input() currencySymbol: string;
  @Input() themeEditorUrl?: string;

  zipCodeAvailableControl = new UntypedFormControl(true);
  LayoutComponentType = ShopPlugin.ProductPagePromise.LayoutComponentType;
  CutoffTimerPosition = ShopPlugin.ProductPagePromise.CutoffTimerPosition;

  get linkedCutoffOptions(): ShopPlugin.ProductPagePromise.CutoffTimerOptions | undefined {
    const cutoff = this.config?.advancedLayoutSettings?.components?.find(
      (c) =>
        c.type === ShopPlugin.ProductPagePromise.LayoutComponentType.CUTOFF_TIMER &&
        c.enabled &&
        (c as ShopPlugin.ProductPagePromise.CutoffTimerComponent).options?.position ===
          ShopPlugin.ProductPagePromise.CutoffTimerPosition.LINKED,
    ) as ShopPlugin.ProductPagePromise.CutoffTimerComponent | undefined;
    return cutoff?.options;
  }
}
